import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./animation.css";
import { cacheExchange, fetchExchange, Provider as GqlProvider } from "urql";
import { createClient } from "urql";
import { Provider } from "react-redux";
import { store } from "./state/store.ts";
import { __sentryInit } from "./sentry.ts";
import { initializeAmplitude } from "./utils/amplitude.ts";

__sentryInit();
if (import.meta.env.VITE_AMPLITUDE_API_KEY) {
  initializeAmplitude(import.meta.env.VITE_AMPLITUDE_API_KEY);
}
const client = createClient({
  url: import.meta.env.VITE_SUBGRAPH_URL,
  exchanges: [cacheExchange, fetchExchange],
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <GqlProvider value={client}>
        <App />
      </GqlProvider>
    </Provider>
  </React.StrictMode>,
);
